import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=36bacefd"
import script from "./TitlePage.vue?vue&type=script&lang=js"
export * from "./TitlePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports